module.exports = __webpack_public_path__ + "img/certificate1.725b1cd9.jpg";